import { gql } from '@apollo/client';

export const DELETE_PURCHASE_LINE = gql`
  mutation DELETE_PURCHASE_LINE($registrationId: String, $purchaseLineId: Int!) {
    deletePurchaseLine: opsPurchaseline(registrationId: $registrationId) {
      purchaseLine: delete(purchaseLineId: $purchaseLineId)
    }
  }
`;
